const googleAnalyticsEvents = {
    openBeneficiariesEditDesignate: {
        eventCategory: 'Profile',
        eventAction: 'Clicked Edit for Beneficiaries',
        eventLabel: 'Edit Designated Beneficiaries'
    },
    eDeliveryTermsAgree: {
        eventCategory: 'eDelivery',
        eventAction: 'Changed Setting for eDelivery',
        eventLabel: 'Agreed to T&C'
    },
    eDeliveryConfirm: {
        eventCategory: 'eDelivery',
        eventAction: 'Clicked Action for eDelivery',
        eventLabel: 'Confirm eDelivery Change'
    }
};

const googleAnalyticsAction = eventType => {
    let eventObject = googleAnalyticsEvents[eventType];

    if (typeof eventObject !== 'undefined') {
        window.ga('send', 'event', eventObject);

        if (eventObject !== null) {
            window.gtag('event', eventObject.eventAction, {
                event_category: eventObject.eventCategory,
                event_label: eventObject.eventLabel
            });
        }
    }
};

export default googleAnalyticsAction;
